import Alert from './Alert.vue'

export default {
  Alert
}



// WEBPACK FOOTER //
// ./src/components/alerts/index.js